var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { EntryComponent } from '../entry/entry.component';
import { AddRowService, Item } from './addrow.service';
import { AddRowDirective } from './addrow.directive';
var AddRowComponent = /** @class */ (function (_super) {
    __extends(AddRowComponent, _super);
    function AddRowComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.changeItems = new EventEmitter();
        _this.child = false;
        _this.parentItems = {};
        _this.parentCols = [];
        _this.items = [];
        _this.dispItems = [];
        _this.deleteItems = [];
        _this.errItems = [];
        _this.uniqueKeys = [];
        _this.readonly = false;
        _this.seq = 1;
        _this.primaryKey = '';
        _this.sortKey = '';
        _this.maxRows = null;
        _this.addable = true;
        _this.deletable = true;
        return _this;
    }
    AddRowComponent.prototype.ngOnChanges = function (changes) {
        if (changes.component) {
            this.getParams();
        }
        if (changes.parentCols) {
            this.cols = $.extend(true, [], this.parentCols);
            this.orgCols = $.extend(true, [], this.cols);
            this.checkReadonly();
        }
        if (changes.parentItems) {
            this.onSubscribe(this.parentItems);
        }
    };
    AddRowComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
        this.getParams();
        this.subsc = this.service.observable.subscribe(function (data) {
            if (data.compName !== _this.componentName) {
                return;
            }
            if (data.flg) {
                _this.addError();
            }
            if (data.err.length > 0) {
                _this.errItems = data.err;
            }
        });
        this.errorSubscription = this.action.errorObservable.subscribe(function (data) {
            if (_this.dir) {
                _this.dir.addValidationError(data.error, data.targetComponents, _this.componentName);
            }
        });
    };
    AddRowComponent.prototype.getParams = function () {
        if (!this.component.params) {
            return;
        }
        var params = this.component.params;
        this.primaryKey = params.primaryKey || '';
        this.sortKey = params.sortKey || '';
        this.maxRows = params.maxRows || null;
        if (!this.primaryKey) {
            this.logger.error('params.primaryKey is not found.');
        }
        if (typeof params.addable !== 'undefined') {
            this.addable = params.addable;
        }
        if (typeof params.deletable !== 'undefined') {
            this.deletable = params.deletable;
        }
    };
    AddRowComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.checkReadonly();
    };
    AddRowComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    AddRowComponent.prototype.onModeSubscribe = function (mode) {
        this.checkReadonly();
    };
    AddRowComponent.prototype.checkReadonly = function () {
        if (!this.orgCols || this.orgCols.length == 0) {
            return;
        }
        this.cols = $.extend(true, [], this.orgCols);
        this.readonly = false;
        if (this.cols[0].readonly === true || this.mode === 'confirm') {
            this.readonly = true;
            _super.prototype.setConfirm.call(this, this.cols);
        }
    };
    AddRowComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        this.dispItems = [];
        this.deleteItems = [];
        this.errItems = [];
        this.uniqueKeys = [];
        var items = [];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array) {
            items = data[this.cols[0].key];
        }
        if (this.cols[0].required && items.length === 0) {
            items.push(new Item());
        }
        this.seq = 1;
        var recs = [];
        var dispRecs = [];
        var deleteRecs = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (typeof item[this.primaryKey] !== 'undefined' && typeof item.$type === 'undefined') {
                item.$type = "put" /* Put */;
            }
            this.rec = {};
            this.dispRec = {};
            _super.prototype.setRecs.call(this, this.cols[0].items, Object.assign(new Item(), { $seq: this.seq++ }, item));
            if (item.$type === "delete" /* Delete */) {
                deleteRecs.push(this.rec);
            }
            else {
                recs.push(this.rec);
                dispRecs.push(this.dispRec);
            }
        }
        this.items = recs;
        this.dispItems = dispRecs;
        this.deleteItems = deleteRecs;
        this.service.setUniqueKeys(this.componentName, this.uniqueKeys);
        this.setCompRec();
    };
    AddRowComponent.prototype.setRec = function (key, readonly, hidden, params, data) {
        _super.prototype.setRec.call(this, key, readonly, hidden, params, data);
        if (this.primaryKey && typeof data[this.primaryKey] !== 'undefined') {
            this.rec[this.primaryKey] = data[this.primaryKey];
        }
        if (this.sortKey && typeof data[this.sortKey] !== 'undefined') {
            this.rec[this.sortKey] = data[this.sortKey];
        }
        if (typeof data['$type'] !== 'undefined') {
            this.rec['$type'] = data['$type'];
        }
        if (typeof data['$seq'] !== 'undefined') {
            this.dispRec['$seq'] = data['$seq'];
        }
        if (typeof data['$editable'] !== 'undefined') {
            this.dispRec['$editable'] = data['$editable'];
        }
        if (typeof params !== 'undefined' && params.unique === true) {
            this.uniqueKeys.push(key);
        }
    };
    AddRowComponent.prototype.trackByItem = function (index, item) {
        return item.$seq;
    };
    AddRowComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'add') {
            this.rec = {};
            this.dispRec = {};
            _super.prototype.setRecs.call(this, this.cols[0].items, Object.assign(new Item(), { $seq: this.seq++ }));
            this.items.push(this.rec);
            this.dispItems.push(this.dispRec);
            this.errItems.push({});
        }
        else if (e2 === 'delete') {
            if (typeof this.items[index][this.primaryKey] !== 'undefined' && this.items[index][this.primaryKey] !== null) {
                this.items[index].$type = "delete" /* Delete */;
                this.deleteItems.push(this.items[index]);
            }
            this.items.splice(index, 1);
            this.dispItems.splice(index, 1);
            this.checkDuplicate();
        }
        else if (e2 === 'up') {
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
            this.dispItems.splice(index - 1, 2, this.dispItems[index], this.dispItems[index - 1]);
            this.errItems.splice(index - 1, 2, this.errItems[index], this.errItems[index - 1]);
            this.service.refreshCol();
        }
        else if (e2 === 'down') {
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
            this.dispItems.splice(index, 2, this.dispItems[index + 1], this.dispItems[index]);
            this.errItems.splice(index, 2, this.errItems[index + 1], this.errItems[index]);
            this.service.refreshCol();
        }
        this.addError();
        this.setCompRec();
    };
    AddRowComponent.prototype.onChangeRow = function (e, index) {
        this.items[index][e.key] = e.val;
        this.dispItems[index][e.key] = e.val;
        this.checkDuplicate();
        this.setCompRec();
    };
    AddRowComponent.prototype.onClickRow = function (e, index) {
        this.action.setRec(this.items[index]);
        this.action.firstAction(e.event);
    };
    AddRowComponent.prototype.setOrder = function () {
        if (!this.sortKey) {
            return;
        }
        var order = 1;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            item[this.sortKey] = order;
            order++;
        }
    };
    AddRowComponent.prototype.setCompRec = function () {
        this.setOrder();
        var items = {};
        items[this.cols[0].key] = this.items.concat(this.deleteItems);
        if (this.child) {
            this.changeItems.emit(items);
            return;
        }
        this.action.setCompRec(this.componentName, items);
    };
    AddRowComponent.prototype.addError = function () {
        if (this.cols[0].required) {
            var errFlg = (this.items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
        }
    };
    AddRowComponent.prototype.checkDuplicate = function () {
        this.errItems = this.service.checkDuplicate(this.componentName, this.items, this.msgSnapshot);
    };
    AddRowComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.service.deleteUniqueKeys(this.componentName);
    };
    AddRowComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'addrow',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" addrowDir></dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly || !sortKey\" scope=\"col\"></th>\n        <th [hidden]=\"readonly || !deletable\" scope=\"col\"></th>\n        <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n          <th *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" scope=\"col\">\n            <a a class=\"-fixed\">{{ col.label }}</a>\n          </th>\n        </ng-template>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly || !sortKey\" class=\"tableWrapper_arrowTd\">\n            <ul class=\"stageFlow_arrows\">\n              <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li><a *ngIf=\"index < dispItems.length - 1\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n            </ul>\n          </td>\n          <td [hidden]=\"readonly || !deletable\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"item?.$editable\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n            <td *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" [col]=\"col\" listDir>\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: item.$editable ? col.readonly : true,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" [err]=\"errItems[index] || {}\" (setChangeVal)=\"onChangeRow($event, index)\" (clickCol)=\"onClickRow($event, index)\"></column>\n            </td>\n          </ng-template>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"addable && !readonly && (maxRows === null || dispItems.length < maxRows)\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onEvent($event, 'add', '')\"></button>\n      </p>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    AddRowComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService }
    ]; };
    AddRowComponent.propDecorators = {
        changeItems: [{ type: Output }],
        child: [{ type: Input }],
        parentItems: [{ type: Input }],
        parentCols: [{ type: Input }],
        dir: [{ type: ViewChild, args: [AddRowDirective,] }]
    };
    return AddRowComponent;
}(EntryComponent));
export { AddRowComponent };
//# sourceMappingURL=addrow.component.js.map